/**
 * ThreadUnreadBadge — the single definition of the unread-message indicator (RA-UNREAD-DEF),
 * used by the Repair Detail thread tabs and the Repairs list rows. Renders nothing at 0.
 */

import { Badge } from '../ui/badge';

export function ThreadUnreadBadge({ count, testId }: { count: number; testId: string }) {
  if (count <= 0) return null;
  return (
    <Badge
      variant="primary"
      data-testid={testId}
      className="rounded-full px-2 py-0 text-xs font-bold"
    >
      <span aria-hidden="true">{count > 99 ? '99+' : count}</span>
      <span className="sr-only">{`${count} unread ${count === 1 ? 'message' : 'messages'}`}</span>
    </Badge>
  );
}
